export type createReplyRequest = {
    name: string,
    email: string,
    eventId: number,
    answer: string,
    inviteId?: string,
    timeAnswers: timeAnswers[]
}

export type updateReplyRequest = {
    name: string,
    email: string,
    eventId: number,
    answer: string,
    inviteId?: string,
    timeAnswers: timeAnswers[]
    replyId: number,
    authCode?: string
}

export type saveHouseholdReplyRequest = {
    eventId: number,
    inviteId: string,
    answer: string,
    people: { memberId: number, timeAnswers: timeAnswers[] }[]
}

export type addGuestReplyRequest = {
    eventId: number,
    name: string,
    email?: string,
    phone?: string,
    timeIds: number[],
    note: string,
    sendConfirmation: boolean
}

export type timeAnswers = {
    timeId: number,
    customerAnswer: CustomerAnswer
}

export enum CustomerAnswer {
    Accept = 0,
    Tentative = 1,
    Reject = 2,
    Waitlist = 3
}